module.exports = __webpack_public_path__ + "static/media/linkimg1.5643bc9b.jpg";